
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BannerCard extends Vue {
  @Prop({ required: true }) private banner!: any;
  @Prop({ required: true }) private index!: number;

  private getImageType(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return name;
    }
    return "/img/activity-default.png";
  }
}
